function initPostsGrid(block) {
    if (block.dataset.p7PostsGridInit) return; // avoid double init
    block.dataset.p7PostsGridInit = '1';

    const container = block;
    const ajaxUrl = container.dataset.ajaxUrl;
    const nonce = container.dataset.nonce;
    const defaultImage = block.dataset.defaultImage || '';
    const postsPerPage = parseInt(container.dataset.postsPerPage || 5);

    const searchInput = container.querySelector(".posts-search");
    const categoryLinks = container.querySelectorAll(".posts-categories a");
    const postsContainer = container.querySelector(".posts-items");
    const paginationContainer = container.querySelector(".posts-pagination");

    if (!ajaxUrl || !nonce || !postsContainer) {
        console.error("Missing data attributes or elements.");
        return;
    }

    let currentPage = 1;
    let currentCategory = 0;
    let maxPages = 1;
    let isLoading = false;

    fetchPosts();

    // Load posts
    function fetchPosts(page = 1) {
        if (isLoading) return;
        isLoading = true;
        currentPage = page;

        if (postsContainer) postsContainer.innerHTML = '<p>Loading...</p>';
        if (paginationContainer) paginationContainer.innerHTML = '';

        const formData = new FormData();
        formData.append("action", "p7_load_posts");
        formData.append("nonce", nonce);
        formData.append("search", searchInput?.value || '');
        formData.append("category", currentCategory);
        formData.append("paged", currentPage);
        formData.append("postsPerPage", postsPerPage);

        fetch(ajaxUrl, { method: "POST", body: formData })
            .then(res => res.json())
            .then(data => {
                if (!data.success) {
                    postsContainer.innerHTML = "<p>Failed to load posts.</p>";
                    console.error("AJAX failed:", data);
                    return;
                }

                postsContainer.innerHTML = '';
                const posts = data.data.posts || [];
                maxPages = data.data.maxPages || 1;

                if (posts.length > 0) {
                    posts.forEach(post => {
                        const item = document.createElement("div");
                        item.className = "p7-post-item";
                        item.innerHTML = `
                            <a href="${post.link}">
                               ${post.thumbnail
                                ? `<div class="p7-img-wrapper"><img class="p7-post-img" src="${post.thumbnail}" alt="${post.title}"></div>`
                                : (defaultImage ? `<div class="p7-img-wrapper"><img class="p7-post-img" src="${defaultImage}" alt="Default"></div>` : '')}
                                <div class="p7-post-meta-tags"><span>In the ${post.categories}</span> - <span>${post.date}</span></div>
                                <h3 class="p7-post-title">${post.title}</h3>
                            </a>
                        `;
                        postsContainer.appendChild(item);
                    });
                } else {
                    postsContainer.innerHTML = "<p>No posts found.</p>";
                }

                renderPagination();
            })
            .catch(err => console.error("Fetch error:", err))
            .finally(() => { isLoading = false; });
    }

    function renderPagination() {
        if (!paginationContainer || maxPages <= 1) return;
        paginationContainer.innerHTML = '';

        const createLink = (text, page, isActive = false, isDisabled = false, extraClass = '') => {
            const a = document.createElement('a');
            a.href = '#';
            a.textContent = text;
            if (isActive) a.classList.add('active');
            if (isDisabled) a.classList.add('hide');
            if (extraClass) a.classList.add(extraClass);
            a.addEventListener('click', e => {
                e.preventDefault();
                if (!isDisabled && !isActive) fetchPosts(page);
            });
            return a;
        };

        // Prev link
        paginationContainer.appendChild(createLink('Prev', currentPage - 1, false, currentPage === 1, 'pagination-prev'));

        const delta = 2; // how many pages to show around current page
        const pages = [];
        for (let i = 1; i <= maxPages; i++) {
            if (i === 1 || i === maxPages || (i >= currentPage - delta && i <= currentPage + delta)) {
                pages.push(i);
            } else if (pages[pages.length - 1] !== '...') {
                pages.push('...');
            }
        }

        pages.forEach(p => {
            if (p === '...') {
                const span = document.createElement('span');
                span.textContent = '...';
                paginationContainer.appendChild(span);
            } else {
                paginationContainer.appendChild(createLink(p, p, p === currentPage));
            }
        });

        // Next link
        paginationContainer.appendChild(createLink('Next', currentPage + 1, false, currentPage === maxPages, 'pagination-next'));
    }


    // Event listeners
    searchInput?.addEventListener('input', () => fetchPosts(1));

    categoryLinks.forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();
            categoryLinks.forEach(l => l.classList.remove('active'));
            link.classList.add('active');
            currentCategory = link.dataset.cat || 0;
            fetchPosts(1);
        });
    });
}

// Observe DOM for dynamically inserted blocks
const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) {
                if (node.classList.contains('p7-posts-list-frontend')) initPostsGrid(node);
                node.querySelectorAll?.('.p7-posts-list-frontend').forEach(initPostsGrid);
            }
        });
    });
});

if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.p7-posts-list-frontend').forEach(initPostsGrid);
});
